import { Component, Input, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
/**
 *
 */
export class CheckboxComponent {
  @Input() formGroup!: UntypedFormGroup;
  @Input() abstractFormControlName!: string;
  @Input() label!: string;
  @Input() anchorTermsText?: string;
  @Input() anchorTermsLink?: string;
  @Input() isInvited?: boolean;
  @Input() isNewUser?: boolean;
  @Input() anchorPrivacyText?: string;
  @Input() anchorPrivacyLink?: string;
  requiredErrorText = 'this-field-is-required';

  /**
   * returns control associated with this checkbox
   */
  get control() {
    return this.formGroup.controls[this.abstractFormControlName];
  }
}
